import $ from 'jquery';
import 'slick-carousel';

export default function videoFeature() {
  $('.roc-video-feature').each(function () {
    const $section = $(this);
    const $slider = $section.find('.js-video-episodes-slider').first();
    const $modal = $section.find('.roc-video-feature__modal');

    $section.addClass('is-enhanced');

    // 🎯 RESET VIDEO ON MODAL CLOSE
    if ($modal.length) {
      $modal.on('closed.zf.reveal', function () {
        const $iframe = $(this).find('iframe');
        const $video = $(this).find('video');

        if ($iframe.length) {
          $iframe.each(function () {
            const src = $(this).attr('src');
            $(this).attr('src', '');
            $(this).attr('src', src);
          });
        }

        if ($video.length) {
          $video.each(function () {
            this.pause();
            this.currentTime = 0;
          });
        }
      });
    }

    // 🎯 SLIDER (FULL — untouched)
    if ($slider.length && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 3.25,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        speed: 550,
        cssEase: 'ease',
        prevArrow: `
          <button type="button" class="slick-prev" aria-label="Previous">
            <span class="arrow-icon arrow-icon--prev" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" style="transform: rotate(180deg);">
                <path d="M0 9.56472H18.6871M18.6871 9.56472L9.83529 0.909668M18.6871 9.56472L9.83529 19.0066" stroke="#082947" stroke-width="2.54449"/>
              </svg>
            </span>
          </button>
        `,
        nextArrow: `
          <button type="button" class="slick-next" aria-label="Next">
            <span class="arrow-icon arrow-icon--next" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path d="M0 9.56472H18.6871M18.6871 9.56472L9.83529 0.909668M18.6871 9.56472L9.83529 19.0066" stroke="#082947" stroke-width="2.54449"/>
              </svg>
            </span>
          </button>
        `,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2.5,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1.5,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1.1,
            },
          },
        ],
      });
    }

    // 🎯 INTERSECTION OBSERVER (unchanged)
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              $section.addClass('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.18,
        }
      );

      observer.observe($section[0]);
    } else {
      $section.addClass('is-visible');
    }
  });
}
